<div class="fader-in">
  <div class="center" [ngStyle]="_style">
    @if (_ready) {
      <div>
        <div >
          @switch (_type) {
            @case (0) {
              <div>
                <div [ngStyle]="_size" class="spinner"></div>
              </div>
            }
            @case (1) {
              <div>
                <div class="parentSvgier">
                  <div id="heart">
                    <svg class="heart-rate" xmlns="http://www.w3.org/2000/svg" width="689px" height="359px" viewBox="0 0 689 359" preserveAspectRatio="xMidYMid meet">
                      <rect id="svgEditorBackground" x="0" y="0" width="689" height="359" style="fill: none; stroke: none;"/>
                      <path style="stroke:white;fill:none;stroke-width:4px;" id="e1_polyline" d="M106.204 222.314 113.506 219.658 124.126 226.296 130.1 203.728 136.738 222.977 140.721 218.331 155.987 230.943 164.617 207.047 169.927 223.641 176.565 219.658 180.547 224.969 196.478 224.969"/>
                    </svg>
                  </div>
                  <div class="gear">
                    <div class="center"></div>
                    <div class="tooth"></div>
                    <div class="tooth"></div>
                    <div class="tooth"></div>
                    <div class="tooth"></div>
                  </div>
                </div>
              </div>
            }
            @case (2) {
              <div>
                <svg class="heartbeat" width="108px" height="128px" viewBox="0 0 54 64" xmlns="http://www.w3.org/2000/svg">
                  <defs></defs>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path class="beat-loader" d="M0.5,38.5 L16,38.5 L19,25.5 L24.5,57.5 L31.5,7.5 L37.5,46.5 L43,38.5 L53.5,38.5" id="Path-2" stroke-width="2"></path>
                  </g>
                </svg>
              </div>
            }
            @case (3) {
              <div>
                <div class="lds-heart"><div></div></div>
              </div>
            }
            @case (4) {
              <div>
                <div class="lds-hourglass"></div>
              </div>
            }
            @case (5) {
              <div>
                <div class="lds-ripple"><div></div><div></div></div>
              </div>
            }
            @case (6) {
              <div>
                <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
              </div>
            }
            @case (7) {
              <div>
                <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
              </div>
            }
            @case (8) {
              <div>
                <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
              </div>
            }
            @case (9) {
              <div>
                <div class="lds-facebook"><div></div><div></div><div></div></div>
              </div>
            }
            @case (10) {
              <div>
                <div class="lds-dual-ring"></div>
              </div>
            }
            @default {
              <div>
                <div [ngStyle]="_size" class="spinner"></div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
